import React, { createContext, useContext, useEffect, useState } from "react";
import {
  getDebugMode,
  setDebugMode,
  subscribeToDebugMode,
} from "../store/debug";

// Define the context type
interface DebugContextType {
  isInDebugMode: boolean;
  toggleDebugMode: () => void;
}

// Create the context
const DebugContext = createContext<DebugContextType | undefined>(undefined);

// Provider component
export const DebugProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isInDebugMode, setIsInDebugMode] = useState<boolean>(getDebugMode());

  useEffect(() => {
    const unsubscribe = subscribeToDebugMode(setIsInDebugMode);
    return () => unsubscribe(); // Cleanup on unmount
  }, []);

  const toggleDebugMode = () => setDebugMode(!isInDebugMode);

  return (
    <DebugContext.Provider value={{ isInDebugMode, toggleDebugMode }}>
      {children}
    </DebugContext.Provider>
  );
};

// Custom hook for using the context in React components
export const useDebug = (): DebugContextType => {
  const context = useContext(DebugContext);
  if (!context) {
    throw new Error("useDebug must be used within a DebugProvider");
  }
  return context;
};
